var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"loc-product-terpenes"},[_c('p',{staticClass:"is-size-16px has-text-weight-semibold mb10"},[_vm._v("Terpenes")]),_vm._l((_vm.terpenes),function(terpene){return _c('div',{key:'terpene_' + terpene.id,staticClass:"terpene-tag text-secondary bg-secondary-light"},[_vm._v("\n   "+_vm._s(terpene.name)+"\n  ")])})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }